/* eslint-disable global-require */
import Error from './Error'
import Failer from './Failer'
import Inverter from './Inverter'
import Limiter from './Limiter'
import MaxTime from './MaxTime'
import MemSelector from './MemSelector'
import MemSequence from './MemSequence'
import Selector from './Selector'
import Repeater from './Repeater'
import RepeatUntilFailure from './RepeatUntilFailure'
import RepeatUntilSuccess from './RepeatUntilSuccess'
import Runner from './Runner'
import Sequence from './Sequence'
import Subtree from './Subtree'
import Succeeder from './Succeeder'
import Wait from './Wait'

export default [
	Error,
	Failer,
	Inverter,
	Limiter,
	MaxTime,
	MemSelector,
	MemSequence,
	Selector,
	Repeater,
	RepeatUntilFailure,
	RepeatUntilSuccess,
	Runner,
	Sequence,
	Subtree,
	Succeeder,
	Wait,
]
